import {
  INIT_COUNTRY_SELECTOR,
  TOGGLE_COUNTRY_SELECTOR,
} from './types';

const initCountrySelector = state => ({
  ...state,
});

const toggleCountrySelector = state => ({
  ...state,
  isCountrySelectorVisible: !state.isCountrySelectorVisible,
});

const reducer = {
  [INIT_COUNTRY_SELECTOR]: initCountrySelector,
  [TOGGLE_COUNTRY_SELECTOR]: toggleCountrySelector,
};

export default (state = {}, action) =>
  (action.type && reducer[action.type] ? reducer[action.type](state, action) : state);
